// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { FormComponentPositionResponse } from './form-component-position-response';

// @ts-ignore
import { RapidReviewFieldValueResponse } from './rapid-review-field-value-response';

// @ts-ignore
import { RapidReviewOdOsResponse } from './rapid-review-od-os-response';

// @ts-ignore
import { RapidReviewRefractionResponse } from './rapid-review-refraction-response';

/** See com.rev360.pms.api.controller.encounter.rapidreview.RapidReviewWorkflowTestResponse */
/* istanbul ignore next */
@GandalfModel
export class RapidReviewWorkflowTestResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	masterCategoryId!: number | null;

	@GandalfProperty({ designType: String })
	name!: string;

	@GandalfArray(RapidReviewOdOsResponse)
	odOsFields!: RapidReviewOdOsResponse[];

	@GandalfArray(RapidReviewFieldValueResponse)
	otherFields!: RapidReviewFieldValueResponse[];

	@GandalfArray(RapidReviewRefractionResponse)
	refractions!: RapidReviewRefractionResponse[];

	@GandalfProperty({ designType: Number })
	screenDisplayOrder!: number;

	@GandalfProperty({ designType: Number })
	stepDisplayOrder!: number;

	@GandalfProperty({ designType: FormComponentPositionResponse })
	testPosition!: FormComponentPositionResponse;

	@GandalfProperty({ designType: Number })
	workflowTestId!: number;

}
